<template>
  <template v-if="['paragraph_block'].includes(block.type)">
    <RichTextBlock
      :html="block.value"
    />
  </template>

  <template v-else-if="block.type === 'heading_block'">
    <HeadingBlock
      :heading-text="block.value.heading_text"
      :size="block.value.size"
    />
  </template>

  <template v-else-if="block.type === 'image_block'">
    <ImageBlock
      height="100%"
      width="auto"
      :title="block.value.image.title"
      :caption="block.value.caption"
      :file="`http://${block.value.image.download_url.replace('//', '/')}`"
    />
  </template>

  <template v-else-if="block.type === 'vertical_spacer'">
    <div :class="block.value.spacing" />
  </template>

  <template v-else>
    <!-- {{block.type}} -->
    <!-- {{block.value}} -->
  </template>
</template>

<script setup lang="ts">
const dataset = {...inject('dataset')}

const injected_block = JSON.parse(dataset.block) || []
//console.log('injected_block', injected_block)
//console.log('injected_pd', injected_pd)

const props = defineProps({
  block: {
    type: Object,
    default: () => {},
  },
  pageData: {
    type: Object,
    default: () => {},
  }
})

const block = computed(() => {
  if (props.block) {
    return props.block
  }
  return injected_block
})
</script>
